import React from 'react';
import { InputPicker } from 'rsuite';
import { BinaryRenderer } from '@/widgets/components/binary-renderer';
import styled from 'styled-components';

const LoadingPickerWrapper = styled.div`
  margin-bottom: 15px;
  margin-top: 5px;
`;

const StyledInputPicker = styled(InputPicker)`
  width: 100%;
`;

export function LoadingPicker({
  onSelect,
  data,
  loading,
  hidden,
  placeholder,
  value,
  defaultValue,
  cleanable,
  dataTestId,
}) {
  if (hidden) return null;

  return (
    <LoadingPickerWrapper>
      <BinaryRenderer checkpoint={!loading} fallback={<span>Loading</span>}>
        <StyledInputPicker
          data-testid={dataTestId}
          placeholder={placeholder}
          onSelect={onSelect}
          data={data}
          defaultValue={defaultValue}
          value={value}
          cleanable={cleanable}
        />
      </BinaryRenderer>
    </LoadingPickerWrapper>
  );
}
